import { cn } from '@/utils/misc'

function Skeleton({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn('animate-pulse rounded-lg bg-secondary/50', className)}
			{...props}
		/>
	)
}

export { Skeleton }
